var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partner_report",staticStyle:{"width":"100%","margin-top":"30px","border-top":"1px solid #ddd"}},[_c('div',{staticStyle:{"width":"100%","height":"300px","margin-top":"20px"}},[_c('canvas',{staticStyle:{"height":"300px","width":"100%"},attrs:{"id":_vm.analysis_data.banner_name_en}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75dcadcc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/SPA/PartnerMypage/Components/PartnerReport/CampaignReportChart.vue
// module id = null
// module chunks = 